import { CoreRankingsHeader } from '../../../views';
import teamplate from './index.jst';
import pre_season_teamplate from './pre_season_teamplate.jst';
import './index.styl';

/**
 * @desc RankingsTipping Header Class
 */
export class RankingsHeader extends CoreRankingsHeader {
	getTemplate() {
		let actual_round = this.rounds.actual;

		if( actual_round ) {
			if(
				actual_round.get('id') === 1 &&
				actual_round.get('status') === 'scheduled'
			) {
				return pre_season_teamplate;
			}
			else {
				return teamplate;
			}
		}

		return false;
	}
}

export default RankingsHeader;